import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/api';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-[#005DE8] mx-auto" />
          <p className="mt-2 text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on role
    const dashboardRoutes = {
      SUPER_ADMIN: '/admin',
      SHOP_OWNER: '/dashboard',
      STORE_MANAGER: '/manager',
      SALES_STAFF: '/sales',
      SUPPORT_AGENT: '/support',
    };
    return <Navigate to={dashboardRoutes[user.role] || '/login'} replace />;
  }

  return children;
}

export function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-[#005DE8] mx-auto" />
          <p className="mt-2 text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (user) {
    const dashboardRoutes = {
      SUPER_ADMIN: '/admin',
      SHOP_OWNER: '/dashboard',
      STORE_MANAGER: '/manager',
      SALES_STAFF: '/sales',
      SUPPORT_AGENT: '/support',
    };
    return <Navigate to={dashboardRoutes[user.role] || '/dashboard'} replace />;
  }

  return children;
}
